import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Slide } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useRemoveUserMutation } from '../../services/api';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteUserDialogBox = ({ open, onClose, user, refetch }) => {
    const theme = useTheme();
    const [removeUser, { isLoading }] = useRemoveUserMutation();

    // handle delete
    const handleDelete = async () => {
        try {
            await removeUser(user._id).unwrap();
            refetch();
            onClose();
        } catch (error) {
            console.error('Failed to delete user:', error);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            PaperProps={{
                sx: {
                    backgroundColor: theme.palette.background.paper,
                    width: '600px',
                    padding: theme.spacing(2),
                },
            }}
        >
            <DialogTitle sx={{ color: theme.palette.text.white }} variant="h2" fontWeight="bold">
                Confirm Delete
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" color="text.primary">
                    Are you sure you want to delete user <strong>{user?.name}</strong>?
                </Typography>
            </DialogContent>
            <DialogActions sx={{ padding: theme.spacing(2) }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        color: theme.palette.text.black,
                        backgroundColor: theme.palette.text.white,
                        fontWeight: 'bold',
                        '&:hover': {
                            backgroundColor: theme.palette.text.white,
                        },
                    }}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleDelete}
                    variant="contained"
                    sx={{
                        color: theme.palette.text.black,
                        backgroundColor: theme.palette.error.main,
                        fontWeight: 'bold',
                        '&:hover': {
                            backgroundColor: theme.palette.error.dark,
                        },
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? 'Deleting...' : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteUserDialogBox;
